<template>
  <div class="p-content-page">
    <page-title v-if="pageLoading">Loading</page-title>
    <page-title v-else>{{page.title}}</page-title>

    <div class="row">
      <div class="col-xs-12 col-md-8">
        <section-block>
          <template slot="header">
            <page-breadcrumb :links="breadcrumb" :currentPage="page"></page-breadcrumb>
          </template>

          <template slot="actions">
            <base-button
              iconBefore="edit"
              @click="onClickEditPage"
              v-if="UserHasPermission && adminEnabled"
            >Edit page</base-button>
          </template>

          <section v-if="pageLapsed && !pageLoading">
            <message type="warning">
              <h3>This page may be outdated</h3>
              <p>The content of this page has now lapsed and is under review</p>
            </message>
          </section>

          <section v-if="!pageLoading && canBeViewed">
            <div
              class="c-element-container"
              :class="{[`c-element-container--${element.type}`]: true}"
              v-for="(element, index) in page.elements"
              :key="element.id"
            >
              <div class="sm-col-6">
                <pb-element :element="forRender[index]"></pb-element>
              </div>
            </div>
          </section>
          <div v-else-if="!pageLoading && !canBeViewed">
            <message type="warning">
              <h3>This page has not been approved</h3>
              <p>Please contact the owner of the page</p>
            </message>
          </div>
          <loading v-if="pageLoading"></loading>
        </section-block>
      </div>
      <div class="col-xs-12 col-md-4">
        <page-navigation :links="menu" :currentPage="page"></page-navigation>
      </div>
    </div>
  </div>
</template>

<script>
import PbElement from "@/components/PbElement";
import PageBreadcrumb from "@/components/PageBreadcrumb";
import PageNavigation from "@/components/PageNavigation";
import { mapState, mapGetters } from "vuex";
import UserHasPermission from "@/mixins/UserHasPermission";
export default {
  name: "content-page",

  components: {
    PbElement,
    PageBreadcrumb,
    PageNavigation
  },

  created() {
    const parts = this.$route.params.pageSlug.split("/");
    this.$store.commit("pageElements/setPageElements", []);
    this.$store
      .dispatch("pages/read", {pageSlugOrId: parts[parts.length - 1], isAdmin: false})
      .then(page => {
        this.$store.commit("pageElements/setPageElements", page.elements);
      })
      .catch(error => {
        if (error.error.status_code == 404) {
          this.$router.push({ name: "error-404" });
        }
      });
  },
  mixins: [UserHasPermission],

  methods: {
    onClickEditPage() {
      this.$router.push({
        name: "AdminContentPageEdit",
        params: { pageId: this.page.id }
      });
    }
  },

  computed: {
    ...mapState({ page: state => state.pages.currentPage }),
    ...mapState("pages", ["breadcrumb", "menu"]),
    ...mapGetters("pages", ["pageUrl"]),
    ...mapGetters("pageElements", ["forRender"]),
    adminEnabled() {
      return !this.$adminDisabled
    },
    pageLoading() {
      return !this.page.id;
    },

    pageLapsed() {
      return (
        this.$dayjs(this.page.review_date).format() < this.$dayjs().format()
      );
    },

    menuLoading() {
      return !this.menu;
    },
    UserHasPermission() {
      return this.userHasPermission("add_edit_pages");
    },

    canBeViewed() {
      if (['pending','rejected'].includes(this.page.status)) {
        return this.page.has_draft
      }
      return this.page.status === 'approved'
    }
  }
};
</script>

<style lang="scss">
.c-element-container {
  @media screen and (min-width: 1200) {
    margin: 2em 0;
  }

  &--accordion-item,
  &--media-resource {
    margin: 0;
  }

  &--base-button,
  &--media-gallery {
    margin-bottom: 1em;
  }

  &--media-file {
    margin-bottom: 0;
    &:last-of-type {
      margin-bottom: 20px;
    }
  }
}
</style>

